"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorDialog_1 = require("spry-react/Errors/errorDialog");
function Render500ErrorDialog(close) {
    return React.createElement(errorDialog_1.ErrorDialog, { close: close, singleTabText: "Unexpected Error" },
        React.createElement(React.Fragment, null,
            React.createElement("h2", null, "An unexpected error occurred"),
            "The details of the error have been logged. Try refreshing the page or clicking the back button and trying the operation again. If the problem persists please contact technical support."));
}
exports.Render500ErrorDialog = Render500ErrorDialog;
